import Cookie from "js-cookie";

const API_URL = "/transparency-portal";
const SESSION_COOKIE_NAME = "tp_session";

export default class AuthorizationManager {

    static get sessionToken() { return Cookie.get(SESSION_COOKIE_NAME); }
    static set sessionToken( sessionToken ) { if (!sessionToken) Cookie.remove(SESSION_COOKIE_NAME); }
    static removeSessionToken() { window.sessionStorage.removeItem("transparencyPortal-Session"); }

    /** Used for anonymous authentication */
    captchaKey = "";

    /**
     * @returns {AuthorizationManager} The instance of the singleton
     */
    static get instance() {
        if (!this._instance) {
            this._instance = new AuthorizationManager();
        }

        return this._instance;
    }

    /**
     * Gets the corresponding guids of the user. Throws if invalid username+password combination
     * @param {string} username The username
     * @param {string} password The password
     * @returns {Promise<{ authKey: string, databaseId: string, containerId: string, host: string }>}
     */
    async login( username = undefined, password = undefined ) {

        // get old session
        var sessionToken = AuthorizationManager.sessionToken;
        if (!(sessionToken || (username && password))) throw new Error("Bitte geben Sie einen Nutzernamen mit Passwort ein.");

        // use either the old session or username and password
        const authenthorization = sessionToken ? `Bearer ${sessionToken}` : `Basic ${btoa(username+":"+password)}`;
        const res = await fetch(API_URL + "/login", {
            method: "POST",
            headers: { Authorization: authenthorization }
        });

        if ( !res.ok ) throw new Error( await res.text() );

        // success
        console.log(`[AUTHORIZATIONMANAGER]: Successfully loggen in! Session: "${sessionToken}"`);

    }

    /**
     * Sends a logout request to the authorization server to delete the session.
     */
    async logout() {

        try {

            // send logout request
            const res = await fetch(API_URL + "/logout", { method: "POST" });

            // check response
            if (!res.ok) throw new Error(`Response was not 200 (OK) but ${res.status}`);

        } catch(e) {
            console.log(`[AUTHORIZATIONMANAGER]: Could not log out: ${e.toString()}`);
            return false;
        }

        return true;

    }

}